<ng-container *ngIf="screenWidth > 768">
  <app-blog-desktop></app-blog-desktop>
</ng-container>

<ng-container *ngIf="screenWidth <= 768">
  <app-blog-mobile></app-blog-mobile>
</ng-container>